// infrastructure/Common/LightTokenGetterApi.ts
import type { Token } from "../../domain/SecuritySlice/Token";

type TokenGetter = () => Token | null;
type Refresher = () => Promise<void>;

export class LightTokenGetterApi {
  private static getToken: TokenGetter = () => null;
  private static refresh: Refresher = async () => { /* noop until configured */ };

  /** Wire the token getter and refresh impl from the app layer (store). */
  static configure(opts: { getToken: TokenGetter; refresh: Refresher }) {
    this.getToken = opts.getToken;
    this.refresh = opts.refresh;
  }

  /** Synchronously get the current access token or throw if missing. */
  static getAccessToken(): string {
    const t = this.getToken?.();
    const access = t?.accessToken;
    if (!access) throw new Error("No access token available. Please log in.");
    return access;
  }

  /** Ask the app layer to refresh tokens (throws if it fails). */
  static async refreshToken(): Promise<void> {
    await this.refresh();
  }
}
